import IntegrationPage from './IntegrationPage';
export default IntegrationPage;
